import { Component } from 'react'
import { result, find } from 'libraries/lodash'

export default class FilterComponent extends Component {
  static defaultProps = {
    basicDisplay: false
  }

  constructor () {
    super(...arguments)
    this.id = Math.random().toString()
  }

  get value () {
    return result(this.props.filterValue, '[0].value', [])
  }

  getOperatorValue (operator) {
    return result(
      find(this.props.filterValue, x => x.operator === operator),
      'value',
      []
    )
  }
}
